import { RelatorioReservasItem } from "features/relatorios/typings";
import { formatMoney } from "infra/helpers/number";
import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { View, Text } from "@react-pdf/renderer";
import moment from "moment";
import { StatusReservaEnum } from "core/features/reservas/typings";

function useRelatorioReservasPdfColumns(): PDFTableColumn<RelatorioReservasItem>[] {
  return useMemo(() => {
    return [
      {
        title: "Data de criação",
        flexGrow: 0.9,
        render: (original) => (
          <View>
            <Text>{moment(original.createdAt).format("DD/MM/YYYY")}</Text>
            {original.origem ? (
              <Text style={{ fontWeight: "light", fontSize: 7.5 }}>
                {original.origem}
              </Text>
            ) : null}
          </View>
        ),
      },
      {
        title: "Data do evento",
        flexGrow: 0.8,
        render: (original) => (
          <View>
            <Text>{moment(original.dataEvento).format("DD/MM/YYYY")}</Text>
            <Text style={{ fontSize: 6 }}>
              {moment(original.horaInicio, "hhmm").format("HH:mm")}
            </Text>
          </View>
        ),
      },
      {
        title: "Área comum",
        flexGrow: 1,
        render: (original) => (
          <View>
            <Text>{original.areaComum ? original.areaComum : "--"}</Text>
          </View>
        ),
      },
      {
        title: "Valor",
        flexGrow: 0.6,
        render: (original) => (
          <View>
            <Text>{formatMoney(original.valor)}</Text>
          </View>
        ),
      },
      {
        title: "Responsável",
        flexGrow: 1.1,
        render: (original) => (
          <View>
            <Text>{original.proprietario}</Text>
            <Text style={{ fontSize: 6 }}>
              {original.unidade}
              {original?.blocoQuadra ? ` - ${original.blocoQuadra.nome}` : ""}
            </Text>
          </View>
        ),
      },
      {
        title: "Status",
        flexGrow: 0.7,
        render: (original) => (
          <View>
            <Text>
              {original.status === StatusReservaEnum.Confirmada
                ? "Confirmada"
                : original.status === StatusReservaEnum.Pendente
                ? "Pendente"
                : original.status === StatusReservaEnum.AguardandoPagamento
                ? "Aguardando Pagamento"
                : original.status === StatusReservaEnum.Cancelada
                ? "Cancelada"
                : null}
            </Text>
          </View>
        ),
      },
      {
        title: "Data de cancelamento",
        flexGrow: 1,
        render: (original) => (
          <View>
            <Text>
              {original.dataCancelamento
                ? moment(original.dataCancelamento).format("DD/MM/YYYY")
                : "--"}
            </Text>
            <Text style={{ fontSize: 6 }}>
              {original.dataCancelamento
                ? moment(original.dataCancelamento).format("HH:mm")
                : ""}
            </Text>
          </View>
        ),
      },
      {
        title: "Quem cancelou",
        flexGrow: 1,
        render: (original) => (
          <View>
            <Text>
              {original.responsavelCancelamento
                ? original.responsavelCancelamento.nome
                : "--"}
            </Text>
          </View>
        ),
      },
    ] as PDFTableColumn<RelatorioReservasItem>[];
  }, []);
}

export default useRelatorioReservasPdfColumns;
